import fadeOut from "./fadeout.js";

const MESSAGE_TYPES = {
    success: "bkgdLtGreen",
    error: "bkgdLtRed textDkRed",
};

const DEFAULTS = {
    role: "alert",
    position: "beforebegin",
};

/* example: StatusMessage.showSuccess(element, "Saved!", { position: "afterend", autoRemove: false });*/

class StatusMessage {
    constructor() {
        this.messageClasses = ["statusMsg", "animate", "animateFadeIn", "text16", "padding5", "paddingLeft10", "textSemiBold", "roundCorners5", "marginTop5", "marginBtm10"];
    }

    showSuccess(element, msg, options = {}) {
        this.showMessage(element, msg, "success", options);
    }

    showError(element, msg, options = {}) {
        this.showMessage(element, msg, "error", options);
    } 

    showMessage(element, msg, type = "success", options = {}) {
        if (!element) {
            console.error("Element to add status message not found.");
            return;
        }

        const {
            position = DEFAULTS.position,
            role = DEFAULTS.role,
            scroll = DEFAULTS.scroll,
            autoRemove = true
        } = options;

        this.clear(element.parentNode || document);

        const messageEl = document.createElement("p");
        messageEl.className = `${MESSAGE_TYPES[type] || ""} ${this.messageClasses.join(" ")}`;
        messageEl.setAttribute("role", role);
        messageEl.innerHTML = msg;

        element.insertAdjacentElement(position, messageEl);

        if (scroll) {
            messageEl.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        const focusTarget = messageEl.querySelector("a, button");
        if (focusTarget) {
            focusTarget.focus();
        }

        if (autoRemove) {
            // automatically remove the message after 15 seconds if not done manually
            setTimeout(() => {
                if(messageEl) {
                    fadeOut(messageEl, () => messageEl.remove());
                }
            }, 15000);
        }
    }

    clear(container = document){
        container.querySelectorAll(".statusMsg").forEach(msg => msg.remove());
    }
}

export default new StatusMessage();